import React from 'react';
import Modal from './Modal';

interface PrivacyPolicyProps {
  isOpen: boolean;
  onClose: () => void;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Privacy Policy">
      <div className="privacy-content">
        <section className="privacy-section">
          <h3>1. Introduction</h3>
          <p>
            At KNOW Bible Trivia ("KNOW," "we," "us," or "our"), we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website, mobile application, or any other services provided by KNOW (collectively, the "Services").
          </p>
          <p>
            Please read this Privacy Policy carefully. By accessing or using our Services, you acknowledge that you have read, understood, and agree to be bound by this Privacy Policy.
          </p>
        </section>
        
        <section className="privacy-section">
          <h3>2. Information We Collect</h3>
          <p>
            We may collect the following types of information:
          </p>
          <h4>2.1 Personal Information</h4>
          <ul>
            <li>Contact information (such as name, email address, and phone number)</li>
            <li>Account credentials</li>
            <li>Profile information (such as display name and profile picture)</li>
          </ul>
          
          <h4>2.2 Usage Information</h4>
          <ul>
            <li>Game performance and progress</li>
            <li>Interaction with our Services</li>
            <li>Device information (such as IP address, browser type, and operating system)</li>
            <li>Log data and analytics</li>
          </ul>
          
          <h4>2.3 Favorites and Preferences</h4>
          <ul>
            <li>Saved Bible verses</li>
            <li>Favorite questions or insights</li>
            <li>Game settings and preferences</li>
          </ul>
        </section>
        
        <section className="privacy-section">
          <h3>3. How We Use Your Information</h3>
          <p>
            We may use the information we collect for various purposes, including:
          </p>
          <ul>
            <li>Providing, maintaining, and improving our Services</li>
            <li>Creating and managing user accounts</li>
            <li>Tracking game progress and displaying leaderboards</li>
            <li>Responding to inquiries and providing customer support</li>
            <li>Sending service-related communications</li>
            <li>Analyzing usage patterns to enhance user experience</li>
            <li>Protecting against fraudulent or unauthorized activity</li>
          </ul>
        </section>
        
        <section className="privacy-section">
          <h3>4. Sharing Your Information</h3>
          <p>
            We may share your information in the following circumstances:
          </p>
          <ul>
            <li><strong>With Service Providers:</strong> We may share your information with third-party service providers who perform services on our behalf, such as hosting, analytics, and customer service.</li>
            <li><strong>For Legal Reasons:</strong> We may disclose your information if required by law or in response to valid legal processes.</li>
            <li><strong>With Your Consent:</strong> We may share your information with third parties when you have given your consent to do so.</li>
            <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of all or a portion of our assets, user information may be transferred as part of the transaction.</li>
          </ul>
        </section>
        
        <section className="privacy-section">
          <h3>5. Data Security</h3>
          <p>
            We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
          </p>
        </section>
        
        <section className="privacy-section">
          <h3>6. Children's Privacy</h3>
          <p>
            Our Services are not directed at children under the age of 13. We do not knowingly collect personal information from children under 13. If we learn that we have collected personal information from a child under 13, we will take steps to delete such information as soon as possible.
          </p>
        </section>
        
        <section className="privacy-section">
          <h3>7. Your Rights and Choices</h3>
          <p>
            Depending on your location, you may have certain rights regarding your personal information, including:
          </p>
          <ul>
            <li>Accessing and updating your personal information</li>
            <li>Requesting deletion of your personal information</li>
            <li>Opting out of certain data collection or use</li>
            <li>Withdrawing consent (where applicable)</li>
          </ul>
          <p>
            To exercise these rights, please contact us using the information provided in the "Contact Us" section below.
          </p>
        </section>
        
        <section className="privacy-section">
          <h3>8. Changes to This Privacy Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.
          </p>
        </section>
        
        <section className="privacy-section">
          <h3>9. Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p>
            Emraay Solutions<br />
            150 King Street West<br />
            Toronto, ON M5H 1J9<br />
            Canada<br />
            Email: privacy@emraay.com
          </p>
        </section>
        
        <div className="privacy-footer">
          <p>Last Updated: May 08, 2023</p>
        </div>
      </div>
    </Modal>
  );
};

export default PrivacyPolicy;